// extracted by mini-css-extract-plugin
module.exports = {"image":"revenue-boosters-module--image--343Il","button":"revenue-boosters-module--button--2WxA1"};